import Tools from "../../base/components/tools";
import EnlacesDirectosHome from "./components/enlacesDirectosHome";
import CustomModal from "../../base/components/modal";
/******************** BUILD ********************/
import less from "../index.less";
/******************** BUILD ********************/

class HomeTransaccional extends React.Component {
  state = {
    configurations: {},
    data: [],
    showError: false
  };

  componentDidMount = () => {
    this.getDirectLinks();
  };

  getDirectLinks = () => {
    const directLinksService = new ServicioProxy(
      "ObtenerEnlacesDirectosAgrupados?home=transacciones",
      "ServicioConsorcioHomes.svc"
    );
    directLinksService
      .getElements("POST", {})
      .then(response => {
        const dataParsed = JSON.parse(response);
        const data = dataParsed.map(item => {
          return {
            Servicio: item.Agrupador,
            principalDirectLink:
              item.Enlaces.length > 3 ? item.Enlaces.slice(0, 3) : item.Enlaces,
            secundaryDirectLink: item.Enlaces.length > 3 ? item.Enlaces : 0,
            open: false
          };
        });

        this.setState({ data });
      })
      .catch(error => {
        console.log(error);
        this.setState({ showError: true });
      });
  };

  collapsePanelDirectLinks = (index, open) => {
    const data = this.state.data;
    data[index].open = open;
    this.setState({ data });
    if (this.state.data[index].open && screen.width <= 768) {
      const elmnt = document.getElementById("enlacesDirectos");
      elmnt.scrollIntoView(true);
    }
  };

  render() {
    const panelStyle = {
      borderBottom: "1px dotted #e2e2e2",
      paddingBottom: "30px",
      marginBottom: "20px"
    };
    const closeModalError = () => {
      this.setState({ showError: false });
    };
    return (
      <div>
        {this.state.showError && (
          <CustomModal LeftButtonAction={closeModalError} />
        )}
        {this.state.data.map((item, index) => (
          <EnlacesDirectosHome
            title={item.Servicio}
            principalDirectLink={item.principalDirectLink}
            secundaryDirectLink={item.secundaryDirectLink}
            index={index}
            panelStyle={panelStyle}
            open={item.open}
            collapsePanelDirectLinks={this.collapsePanelDirectLinks}
          />
        ))}
      </div>
    );
  }
}

const Button = ReactBootstrap.Button;
const Panel = ReactBootstrap.Panel;

const appId = document.getElementById("home-transaccional");
ReactDOM.render(<HomeTransaccional />, appId);



// WEBPACK FOOTER //
// ./newHome/src/index.js